export default __webpack_public_path__ + "static/media/Error.7155d9f2.svg";